import React, { useEffect, useState } from 'react';
import Button from '../ui/Button';
import { formatGhs, getPriceRange } from '../../utils/pricingUtils';

const FinalPriceEditor = ({ item, onFinalize }) => {
  const { minimum, maximum } = getPriceRange(item);
  const [value, setValue] = useState(String(minimum || ''));
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setValue(String(minimum || ''));
    setError('');
  }, [item?.serviceItemId, item?.id, minimum, maximum]);

  const submit = async (event) => {
    event.preventDefault();
    const finalUnitPrice = Number(value);
    if (!Number.isFinite(finalUnitPrice) || finalUnitPrice < minimum || finalUnitPrice > maximum) {
      setError(`Enter an amount between ${formatGhs(minimum)} and ${formatGhs(maximum)}.`);
      return;
    }

    setIsSubmitting(true);
    setError('');
    try {
      await onFinalize(finalUnitPrice);
    } catch (submissionError) {
      setError(submissionError?.data?.message || 'The final price could not be saved.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-2 rounded-lg bg-warning/10 p-2.5">
      <label className="block text-xs font-medium text-foreground font-caption">
        Set final price
      </label>
      <p className="mt-0.5 text-[11px] text-muted-foreground font-caption">
        This can only be set once. Allowed range: {formatGhs(minimum)} to {formatGhs(maximum)}.
      </p>
      <div className="mt-2 flex items-center gap-2">
        <div className="flex h-9 min-w-0 flex-1 items-center rounded-md border border-input bg-background px-3 focus-within:ring-2 focus-within:ring-ring">
          <span className="mr-1 text-xs text-muted-foreground font-caption">GH¢</span>
          <input
            type="number"
            min={minimum}
            max={maximum}
            step="0.01"
            value={value}
            onChange={(event) => { setValue(event.target.value); setError(''); }}
            disabled={isSubmitting}
            className="h-full min-w-0 flex-1 border-0 bg-transparent p-0 text-sm text-foreground outline-none focus:ring-0"
            aria-label={`Final price for ${item.name}`}
          />
        </div>
        <Button type="submit" size="sm" loading={isSubmitting}>Set price</Button>
      </div>
      {error && <p className="mt-2 text-xs text-error font-caption">{error}</p>}
    </form>
  );
};

export default FinalPriceEditor;
